import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  IStudentFlexibleRateVersion,
  IStudentFlexibleRateVersionDeleteVerificationData,
} from '.';
import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';

export type TAdminCreateStudentFlexibleRateVersion = {
  name: IStudentFlexibleRateVersion['name'];
};

export type TAdminGetStudentFlexibleRateVersions = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateStudentFlexibleRateVersion = {
  id: string;
  name: IStudentFlexibleRateVersion['name'];
};

const apiDataProvider = new APIDataProvider();

const adminGetStudentFlexibleRateVersionsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetStudentFlexibleRateVersions) => {
  let path = `${AdminApiPaths.adminStudentFlexibleRateVersions}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IStudentFlexibleRateVersion>>
  >(path);

  return response.data;
};

export const adminCreateStudentFlexibleRateVersion = createAsyncThunk(
  '/admin/student-flexible-rate-versions/create',
  async (data: TAdminCreateStudentFlexibleRateVersion) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRateVersions}`;

    const response = await apiDataProvider.post<
      TApiResponse<IStudentFlexibleRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateStudentFlexibleRateVersion = createAsyncThunk(
  '/admin/student-flexible-rate-versions/update',
  async (data: TAdminUpdateStudentFlexibleRateVersion) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRateVersions}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IStudentFlexibleRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteStudentFlexibleRateVersion = createAsyncThunk(
  '/admin/student-flexible-rate-versions/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRateVersions}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IStudentFlexibleRateVersion>
    >(path);

    return response.data;
  }
);

export const adminVerifyStudentFlexibleRateVersionDelete = createAsyncThunk(
  '/admin/student-flexible-rate-versions/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentFlexibleRateVersions}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IStudentFlexibleRateVersionDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetStudentFlexibleRateVersions = createAsyncThunk(
  '/admin/student-flexible-rate-versions/list',
  adminGetStudentFlexibleRateVersionsModule
);

export const adminGetStudentFlexibleRateVersionsForDropDown = createAsyncThunk(
  '/admin/student-flexible-rate-versions/dropdown-list',
  adminGetStudentFlexibleRateVersionsModule
);
